import { firebase } from '../firebase/config';
import { functions } from '../firebase/config';

export const importFiles = (csv, acceptedFiles, user) => {
    return new Promise((resolve, reject) => {
        let fileReader;
        console.log("CSV", csv);
        console.log("POs", acceptedFiles); 

        const storageRef = firebase.storage().ref();
        const poPath = 'companies/' + user.company + '/poAttachments/';

        let poLinks = {};
        let filePromises = [];
        for (const file of acceptedFiles) {
            filePromises.push(uploadFileAndReturnDownloadableUrl(poPath, storageRef, file)
                .then((fileUrlObj) => {
                    poLinks[file.name] = fileUrlObj.url;
                })
            ) 
        }

        Promise.all(filePromises)
            .then(() => {
                console.log(poLinks);
                fileReader = new FileReader();
                fileReader.onloadend = function(e) {
                    const content = fileReader.result;
                    functions.httpsCallable('parseCSV')({
                        user: user,
                        poLinks: poLinks,
                        csv: content
                    })
                        .then((result) => {
                            resolve(result.data);
                        })
                        .catch((error) => {
                            reject(error.message)
                        });
                };
                fileReader.readAsText(csv);
            })
    })
}

const uploadFileAndReturnDownloadableUrl = (storagePath, storageRef, file) => {
    return new Promise((resolve, reject) => {
        if (file !==  null) {
            // Added newDate().getTime() below b/c >1 file of the same name might be uploaded, 
            // and existing file in storage should not be replaced (paths must be unique).
            let fileRef = storageRef.child(storagePath + new Date().getTime() + '-' + file.name);
            let uploadTask = fileRef.put(file);
            uploadTask.on('state_changed', snapshot => {
                //var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                //console.log('Upload is ' + progress + '% done');
              }, error => {
                // Handle unsuccessful uploads
                //console.log('upload file error', error);
                console.log("Error uploading file", error);
                reject(error);

              }, () => {
                // Handle successful uploads on complete
                uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                    //console.log('File available at', downloadURL);
                    resolve({
                      name: file.name,
                      url: downloadURL
                    });
                })
                .catch(error => {
                    console.log("Error getting download url", error);
                    reject(error);
                });
              });
        } else {
            resolve(null);
        }
    });
}
